export default {
    methods: {
        pricePrettyPrint(
            numberValue,
            symbol,
            currencyCode,
            language = 'en-US',
            displayCurrencyCode = true
        ) {
            // TODO: Improve price localization consistently throughout site via Intl.NumberFormat & similar:
            // hardcoding en-US until we decide to localize prices properly everywhere
            let formattedVal = Intl.NumberFormat(language, {
                style: 'currency',
                currency: currencyCode
            }).format(numberValue);
            formattedVal = formattedVal.match(/[\d]+[.,]*[\d]*[.,]*[\d]*/g)[0];

            let prettyPrice = `${symbol}${formattedVal}`;

            if (displayCurrencyCode) {
                prettyPrice += ` ${currencyCode}`;
            }

            return prettyPrice;
        }
    }
};
